<div class="d-flex align-items-center justify-content-center">
  <nb-card style="max-width: 450px">
    <nb-card-header class="d-flex flex-column align-items-center p-4">
      <img src="assets/img/logo.png" height="32px" alt="logo" />
      <div class="mt-2" style="font-size: large">Insight Engine UI - {{ environment }}</div>
    </nb-card-header>
    <nb-card-body class="d-flex flex-column align-items-center p-4" *ngIf="!accessDenied">
      <app-spinner></app-spinner>
      <div style="font-size: medium; font-weight: 600" i18n>Loading...</div>
    </nb-card-body>
    <nb-card-body class="d-flex flex-column align-items-center p-4" *ngIf="accessDenied">
      <div><nb-icon style="width: 100px; height: 100px" status="basic" icon="lock-outline"></nb-icon></div>
      <div class="mt-2" style="font-size: x-large; font-weight: 600" i18n>Access Denied</div>
      <div class="text-center mt-5" i18n>You don't have permission to use this tool.</div>
      <div class="text-center" i18n>
        Please contact Insights Team via #data-insight-engine slack channel to request access.
      </div>
    </nb-card-body>
  </nb-card>
</div>
